import type { TRssDirectoryEntry, TRssDirectoryRef } from '../models/rssDirectory'
import { getRssDirectoryEntry } from './rssDirectoryCatalog'

/** Preset id stored in UI selects; maps to `maxAgeSec` on `rssDirectoryRef.overrides`. */
export const RSS_MAX_AGE_PRESET_IDS = [
  'not-set',
  'last-hour',
  'last-day',
  'last-month'
] as const

export type TRssMaxAgePresetId = (typeof RSS_MAX_AGE_PRESET_IDS)[number]

export const RSS_MAX_AGE_PRESETS: ReadonlyArray<{
  id: TRssMaxAgePresetId
  maxAgeSec: number
}> = [
  { id: 'not-set', maxAgeSec: 0 },
  { id: 'last-hour', maxAgeSec: 3600 },
  { id: 'last-day', maxAgeSec: 86_400 },
  { id: 'last-month', maxAgeSec: 2_592_000 }
]

const presetBySec = new Map(RSS_MAX_AGE_PRESETS.map(p => [p.maxAgeSec, p.id]))

/** Default article age when catalog/override omit `maxAgeSec` (last day). */
export const DEFAULT_RSS_MAX_AGE_SEC = 86_400

export function resolveRssMaxAgeSec(
  ref: TRssDirectoryRef,
  entry?: TRssDirectoryEntry | null
): number {
  const resolvedEntry = entry ?? getRssDirectoryEntry(ref.entryId)
  return ref.overrides?.maxAgeSec ?? resolvedEntry?.defaults.maxAgeSec ?? DEFAULT_RSS_MAX_AGE_SEC
}

export function rssMaxAgePresetIdFromSec(maxAgeSec: number): TRssMaxAgePresetId {
  return presetBySec.get(maxAgeSec) ?? 'not-set'
}

export function rssMaxAgeSecFromPresetId(presetId: TRssMaxAgePresetId): number {
  const preset = RSS_MAX_AGE_PRESETS.find(p => p.id === presetId)
  return preset?.maxAgeSec ?? 0
}
